const paymentMethods = {
  manual: {
    manual: 'Manual',
  },
  stripe: {
    card: 'Card',
    us_bank_account: 'ACH Direct Debit',
    bacs_debit: 'Bacs Direct Debit',
    au_becs_debit: 'BECS Direct Debit',
    sepa_debit: 'SEPA Debit',
    bancontact: 'Bancontact',
    customer_balance: 'Bank transfers',
    blik: 'BLIK',
    eps: 'EPS',
    fpx: 'FPX',
    giropay: 'Giropay',
    ideal: 'iDEAL',
    p24: 'Przelewy24',
    sofort: 'SOFORT',
    affirm: 'Affirm',
    afterpay_clearpay: 'Afterpay and Clearpay',
    klarna: 'Klarna',
    cards: 'Cards',
    link: 'Link',
    paynow: 'PayNow',
    promptpay: 'PromptPay',
    boleto: 'Boleto',
    konbini: 'Konbini',
    oxxo: 'OXXO',
    alipay: 'Alipay',
    grabpay: 'GrabPay',
    wechat_pay: 'WeChat Pay',
    google_pay: 'Google Pay',
    apple_pay: 'Apple Pay',
  },
  /* paypal: [
    {
      value: 'paypal',
      label: 'Paypal',
      productTypes: ['charge'],
    },
  ], */
};

const wallets = {
  apple_pay: 'Apple Pay',
  google_pay: 'Google Pay',
};

const brands = {
  amex: 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  eftpos_au: 'EFTPOS',
  jcb: 'JCB',
  mastercard: 'Mastercard',
  unionpay: 'UnionPay',
  visa: 'Visa',
  unknown: 'Unknown',
};

function getStripePaymentMethodLabel(paymentMethod, { includeBrand } = { includeBrand: false }) {
  let label = paymentMethods.stripe[paymentMethod.method];

  if (!label) {
    label = paymentMethod.method;
  }

  if (includeBrand === true && paymentMethod.method === 'card') {
    label = `${brands[paymentMethod.brand]} ending in •••• ${paymentMethod.last4}`;
  }

  if (paymentMethod.method === 'card' && paymentMethod.wallet) {
    const walletLabel = wallets[paymentMethod.wallet];

    if (paymentMethod.mode === 'express') {
      return `${label} (${walletLabel} Express)`;
    }

    return `${label} (${walletLabel})`;
  }

  return label;
}

export default function getPaymentMethodLabel(paymentMethod, options) {
  const { method, gateway } = paymentMethod;
  if (!method || !gateway) {
    return '';
  }
  const match = paymentMethods[gateway][method];

  if (gateway === 'manual') {
    return match;
  }

  if (gateway === 'paypal') {
    return match.label;
  }

  const stripePaymentMethodLabel = getStripePaymentMethodLabel(paymentMethod, options);

  return stripePaymentMethodLabel;
}
